import Swal, { SweetAlertOptions } from 'sweetalert2';
import { Observable } from 'rxjs';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConfirmService {
  defaultAlertOptions = {
    showCancelButton: true,
    title: this.translate.instant('Confirmation'),
    confirmButtonColor: '#4099ff',
    cancelButtonColor: '#d33',
    cancelButtonText: this.translate.instant('No'),
    confirmButtonText: this.translate.instant('YesConfirm'),
  };

  constructor(private readonly translate: TranslateService) {}

  confirmPipe(alertOptions: SweetAlertOptions, onConfirm: () => any, onCancel?: () => any): Observable<boolean> {
    return fromPromise(Swal.fire({ ...this.defaultAlertOptions, ...alertOptions })).pipe(
      map((confirm) => {
        if (confirm.value) {
          onConfirm();
          return true;
        } else {
          if (onCancel) onCancel();
          return false;
        }
      }),
    );
  }

  confirm(alertOptions: SweetAlertOptions, onConfirm: () => any, onCancel?: () => any) {
    this.confirmPipe(alertOptions, onConfirm, onCancel).subscribe();
  }
}
